var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55813 1.30232C9.48415 1.4052 10.3175 1.8532 10.9767 2.51163C11.636 3.17005 12.082 4.00432 12.186 4.93023M8.25581 3.4186C8.70155 3.50556 9.14398 3.70213 9.46511 4.02325C9.78624 4.34437 9.98281 4.78683 10.0698 5.23255M4.4468 9.04125C0.275931 4.8699 0.86902 2.95976 1.3087 2.34423C1.36518 2.24475 2.7574 0.160672 4.24975 1.38339C7.95396 4.43408 3.4186 4.32558 6.37498 7.1138C9.33136 9.90203 9.05479 5.53485 12.1049 9.2383C13.3277 10.7312 11.2436 12.1234 11.1447 12.1793C10.5292 12.6196 8.61829 13.2126 4.4468 9.04125Z",
    stroke: "#7B7C94",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.938a8eb89b72b851c8e19666b465af55.svg";
export { ForwardRef as ReactComponent };